import { useRef } from 'react';

import { RowDoubleClickedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';

import { useAppSelector } from '@/app/hooks';
import { useGetAllOpenRequestsQuery } from '@/app/services/issues';
import { WithLocalStorage } from '@/components/hoc';
import { useDefaultGridOptions } from '@/grid';
import { defaultColDef } from '@/grid/defaults';

import { myRequestsColumnDefs } from '../columnDefs';
import { getAllRequestsVariables } from '../constants';
import { useSelect } from '../useSelect';

export const AllOpenRequests = () => {
  const defaultGridOptions = useDefaultGridOptions();
  const { mode } = useAppSelector((state) => state.preferences);
  const { me } = useAppSelector((state) => state.authentication);
  const selectIssue = useSelect();

  const gridRef = useRef<AgGridReact>(null);

  const { data: allOpenRequestsData } = useGetAllOpenRequestsQuery(
    getAllRequestsVariables(me),
  );

  const handleSelect = (event: RowDoubleClickedEvent) => {
    selectIssue(event.data);
  };

  return (
    <WithLocalStorage storageKey="closed-issues-grid">
      <AgGridReact
        gridOptions={defaultGridOptions}
        ref={gridRef}
        className={`ag-theme-transova${mode === 'dark' ? '-dark' : ''}`}
        defaultColDef={defaultColDef}
        columnDefs={myRequestsColumnDefs}
        rowData={allOpenRequestsData}
        overlayLoadingTemplate="Loading open issues..."
        rowSelection="single"
        onRowDoubleClicked={handleSelect}
      />
    </WithLocalStorage>
  );
};
